import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            {aboutInfo.title}
          </h2>
          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutInfo.content}
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3 md:gap-4">
            {aboutInfo.highlights.map((item, idx) => (
              <span
                key={idx}
                className="px-5 py-2 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}